import Header from "../navigation/headerContainer";
import PropertyContainer from "./propertyContainer";
import Footer from "../navigation/footerContainer";


export default function PropertiesPage(){

    return(
        <>
            <Header />
            <PropertyContainer />
            <Footer />
        </>
    )

}